import type { BoggleBadgeCheck } from '../checkTypes'
import { isAcceptedWordEntry } from '../checkTypes'
import { isPalindromeWord } from '../wordAnalysis'

export const palindromeCheck: BoggleBadgeCheck = (ledger, index) => {
  const entry = ledger[index]
  return isAcceptedWordEntry(entry) && isPalindromeWord(entry.word)
}
